function errorHandler(status,data,{includeData}={}){
	if(status === 400) return "Error de la solicitud"
	if(status === 401) return "No autorizado"
	if(status === 403) return "Prohibído"
	if(status === 404) return "No se encontró el documento"
	if(status === 500) return "Error del servidor"
	if(status === 502) return "Se perdió la conexión con el servidor"
	return "Error desconocido"
}
export default errorHandler